import {AlertIcon, CommentIcon, FileIcon} from '@primer/octicons-react'
import {CollapsiblePanel} from './CollapsiblePanel'
import {ExpandableContent} from './ExpandableContent'
import styles from './ChangeSummary.module.css'

/** Change summary section listing grouped changes */
export function ChangeSummary() {
  return (
    <CollapsiblePanel heading="Change summary">
      <ExpandableContent sectionLabel="Change summary">
        <div className={styles.list}>
          <OverviewSummaryItem
            number={1}
            title="Component tests"
            description="Commodo elit adipiscing ornare ullamcorper pretium mauris vulputate hendrerit netus. Et metus cursus pretium quis tincidunt. Ultricies nunc molestie pharetra interdum. Vitae massa tortor egestas velit eget tellus."
            files={[
              {path: 'path/filename', additions: 'NN', deletions: 'NN', warnings: 'NN', comments: 'NN'},
              {path: 'path/filename', additions: 'NN', deletions: 'NN'},
            ]}
          />
        </div>
      </ExpandableContent>
    </CollapsiblePanel>
  )
}

interface FileEntry {
  path: string
  additions: string
  deletions: string
  warnings?: string
  comments?: string
}

interface OverviewSummaryItemProps {
  number: number
  title: string
  description: string
  files: FileEntry[]
}

function OverviewSummaryItem({number, title, description, files}: OverviewSummaryItemProps) {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemHeader}>
        <span className={styles.itemNumber}>{number}</span>
        <h4 className={styles.itemTitle}>{title}</h4>
      </div>
      <p className={styles.itemDescription}>{description}</p>
      <div className={styles.fileList}>
        {files.map(file => (
          <FileRow key={file.path} file={file} />
        ))}
      </div>
    </div>
  )
}

function FileRow({file}: {file: FileEntry}) {
  return (
    <div className={styles.fileRow}>
      <span className={styles.fileInfo}>
        <FileIcon size={16} className={styles.fileIcon} />
        <span className={styles.fileName}>{file.path}</span>
        <span className={styles.additions}>+{file.additions}</span>
        <span className={styles.deletions}>-{file.deletions}</span>
      </span>
      <span className={styles.countGroup}>
        {file.warnings && (
          <span className={styles.countItem}>
            <AlertIcon size={16} />
            {file.warnings}
          </span>
        )}
        {file.comments && (
          <span className={styles.countItem}>
            <CommentIcon size={16} />
            {file.comments}
          </span>
        )}
      </span>
    </div>
  )
}
